// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/management/api/user.proto (package gx.management.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_management_resources_user } from "../resources/user_pb.js";
import { file_services_management_resources_user_tenant } from "../resources/user_tenant_pb.js";

/**
 * Describes the file services/management/api/user.proto.
 */
export const file_services_management_api_user = /*@__PURE__*/
  fileDesc("CiJzZXJ2aWNlcy9tYW5hZ2VtZW50L2FwaS91c2VyLnByb3RvEhFneC5tYW5hZ2VtZW50LmFwaSIXChVHZXRDdXJyZW50VXNlclJlcXVlc3QiTQoWR2V0Q3VycmVudFVzZXJSZXNwb25zZRIzCgR1c2VyGAEgASgLMiUuZ3gubWFuYWdlbWVudC5yZXNvdXJjZXMuVXNlclJlc291cmNlIiEKDkdldFVzZXJSZXF1ZXN0Eg8KB3VzZXJfaWQYASABKAkiRgoPR2V0VXNlclJlc3BvbnNlEjMKBHVzZXIYASABKAsyJS5neC5tYW5hZ2VtZW50LnJlc291cmNlcy5Vc2VyUmVzb3VyY2UiKAoVR2V0VXNlclRlbmFudHNSZXF1ZXN0Eg8KB3VzZXJfaWQYASABKAkiWwoWR2V0VXNlclRlbmFudHNSZXNwb25zZRJBCgx1c2VyX3RlbmFudHMYASADKAsyKy5neC5tYW5hZ2VtZW50LnJlc291cmNlcy5Vc2VyVGVuYW50UmVzb3VyY2UijQEKGFVwZGF0ZUN1cnJlbnRVc2VyUmVxdWVzdBISCgpmaXJzdF9uYW1lGAEgASgJEhEKCWxhc3RfbmFtZRgCIAEoCRJKChVwcm92aWRlZF9qb2JfZnVuY3Rpb24YAyABKA4yKy5neC5kYXRhYmFzZS5tb2RlbHMuVXNlclByb3ZpZGVkSm9iRnVuY3Rpb24iUAoZVXBkYXRlQ3VycmVudFVzZXJSZXNwb25zZRIzCgR1c2VyGAEgASgLMiUuZ3gubWFuYWdlbWVudC5yZXNvdXJjZXMuVXNlclJlc291cmNlIiQKEURlbGV0ZVVzZXJSZXF1ZXN0Eg8KB3VzZXJfaWQYASABKAkiJQoSRGVsZXRlVXNlclJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAgy+AMKC1VzZXJTZXJ2aWNlEmUKDkdldEN1cnJlbnRVc2VyEiguZ3gubWFuYWdlbWVudC5hcGkuR2V0Q3VycmVudFVzZXJSZXF1ZXN0GikuZ3gubWFuYWdlbWVudC5hcGkuR2V0Q3VycmVudFVzZXJSZXNwb25zZRJQCgdHZXRVc2VyEiEuZ3gubWFuYWdlbWVudC5hcGkuR2V0VXNlclJlcXVlc3QaIi5neC5tYW5hZ2VtZW50LmFwaS5HZXRVc2VyUmVzcG9uc2USZQoOR2V0VXNlclRlbmFudHMSKC5neC5tYW5hZ2VtZW50LmFwaS5HZXRVc2VyVGVuYW50c1JlcXVlc3QaKS5neC5tYW5hZ2VtZW50LmFwaS5HZXRVc2VyVGVuYW50c1Jlc3BvbnNlEm4KEVVwZGF0ZUN1cnJlbnRVc2VyEisuZ3gubWFuYWdlbWVudC5hcGkuVXBkYXRlQ3VycmVudFVzZXJSZXF1ZXN0GiwuZ3gubWFuYWdlbWVudC5hcGkuVXBkYXRlQ3VycmVudFVzZXJSZXNwb25zZRJZCgpEZWxldGVVc2VyEiQuZ3gubWFuYWdlbWVudC5hcGkuRGVsZXRlVXNlclJlcXVlc3QaJS5neC5tYW5hZ2VtZW50LmFwaS5EZWxldGVVc2VyUmVzcG9uc2VCzQEKFWNvbS5neC5tYW5hZ2VtZW50LmFwaUIJVXNlclByb3RvUAFaQ2dpdGh1Yi5jb20vZ2FsYXh5LWlvL2d4L3NoYXJlZC9nby9jb250cmFjdHMvc2VydmljZXMvbWFuYWdlbWVudC9hcGmiAgNHTUGqAhFHeC5NYW5hZ2VtZW50LkFwacoCEUd4XE1hbmFnZW1lbnRcQXBp4gIdR3hcTWFuYWdlbWVudFxBcGlcR1BCTWV0YWRhdGHqAhNHeDo6TWFuYWdlbWVudDo6QXBpYgZwcm90bzM", [file_services_database_models_public, file_services_management_resources_user, file_services_management_resources_user_tenant]);

/**
 * Describes the message gx.management.api.GetCurrentUserRequest.
 * Use `create(GetCurrentUserRequestSchema)` to create a new message.
 */
export const GetCurrentUserRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 0);

/**
 * Describes the message gx.management.api.GetCurrentUserResponse.
 * Use `create(GetCurrentUserResponseSchema)` to create a new message.
 */
export const GetCurrentUserResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 1);

/**
 * Describes the message gx.management.api.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 2);

/**
 * Describes the message gx.management.api.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 3);

/**
 * Describes the message gx.management.api.GetUserTenantsRequest.
 * Use `create(GetUserTenantsRequestSchema)` to create a new message.
 */
export const GetUserTenantsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 4);

/**
 * Describes the message gx.management.api.GetUserTenantsResponse.
 * Use `create(GetUserTenantsResponseSchema)` to create a new message.
 */
export const GetUserTenantsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 5);

/**
 * Describes the message gx.management.api.UpdateCurrentUserRequest.
 * Use `create(UpdateCurrentUserRequestSchema)` to create a new message.
 */
export const UpdateCurrentUserRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 6);

/**
 * Describes the message gx.management.api.UpdateCurrentUserResponse.
 * Use `create(UpdateCurrentUserResponseSchema)` to create a new message.
 */
export const UpdateCurrentUserResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 7);

/**
 * Describes the message gx.management.api.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 8);

/**
 * Describes the message gx.management.api.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user, 9);

/**
 * @generated from service gx.management.api.UserService
 */
export const UserService = /*@__PURE__*/
  serviceDesc(file_services_management_api_user, 0);

